import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the page and the nav both call it. */
export function canViewDashboard(can: (capability: Capability) => boolean): boolean {
  return can('AGGREGATES_VIEW')
}
